interface InputFieldProps {
	label: string;
	error?: string;
	children: React.ReactNode;
}

export function InputField({ label, error, children }: InputFieldProps) {
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
			<label
				style={{
					fontSize: "var(--text-caption)",
					fontWeight: 500,
					color: "var(--fg-2)",
					fontFamily: "var(--font-sans)",
				}}
			>
				{label}
			</label>
			{children}
			{error && (
				<p
					className="select-text"
					style={{
						margin: 0,
						fontSize: "var(--text-caption)",
						color: "var(--danger)",
						fontFamily: "var(--font-sans)",
					}}
				>
					{error}
				</p>
			)}
		</div>
	);
}
